<template>
  <div class="order-list-component">
    <template v-if="list.length > 0">
      <ym-loadmore class="order-list"
                   v-model="loading"
                   :finished="allLoad"
                   @load="fetchData"
      >
        <div class="item"
             v-for="(item, index) in list"
             :key="index"
        >
          <div class="status-block">
            <div class="date"
                 v-if="item.order.createdTime > 0"
            >
              {{ item.order.createdTime|formatTime('yyyy-MM-dd HH:ii') }}
            </div>
            <div class="status"
                 :class="{ 'highlight': item.order.status === 'created' }"
            >
              {{ item.order.status | statusFilters }}
            </div>
          </div>
          <div class="order-info"
               @click="handleOrderDetail(item.order.sn)"
          >
            <cover class="cover"
                   :cover="item.product.cover"
                   :alt="item.order.title"
            />
            <div class="product-info">
              <h3 class="title ym-two-line-ellipsis">{{ item.order.title }}</h3>
              <div v-if="item.order.payment === 'balancePay'"
                   class="price-block"
              >
                应付
                <span class="price">
                  {{ item.order.balanceAmount }}少商币
                </span>
              </div>
              <div v-else
                   class="price-block"
              >
                应付金额
                <span class="price"
                      :class="{'active': item.order.status === 'created'}"
                >
                ￥<span>{{ item.order.amount }}</span>
              </span>
              </div>
            </div>
          </div>
          <div class="tool-block">
            <template v-if="item.order.status === 'created'">
              <ym-button size="extra-small"
                         plain
                         @click="handleCancelOrder(item.order.sn)"
              >
                取消订单
              </ym-button>
              <ym-button class="tool-right-btn"
                         size="extra-small"
                         type="primary"
                         @click="handlePayOrder(item.pay.weChatUrl, item.order.sn)"
              >
                立即支付
              </ym-button>
            </template>
            <template v-else>
              <ym-button size="extra-small"
                         type="gray"
                         plain
                         @click="handleOrderDetail(item.order.sn)"
              >
                订单详情
              </ym-button>
              <ym-button v-if="item.express"
                         class="express-btn"
                         size="extra-small"
                         type="gray"
                         plain
                         @click="handleExpressDetail(item.express, item.order.sn)"
              >
                {{ item.express.text }}
              </ym-button>
              <ym-button class="tool-right-btn"
                         size="extra-small"
                         type="primary"
                         plain
                         v-if="item.render.showReviewBtn"
                         @click="handleCourseReview(item.product.type, item.product.id)"
              >
                评价课程
              </ym-button>
              <ym-button class="tool-right-btn"
                         size="extra-small"
                         type="primary"
                         v-if="item.render.showJoinBtn"
                         @click="handleProductDetail(item.product)"
              >
                再次购买
              </ym-button>
              <ym-button class="tool-right-btn"
                         size="extra-small"
                         type="primary"
                         plain
                         v-if="item.render.showShareBtn"
                         @click="handleProductDetail(item.product)"
              >
                分享好友
              </ym-button>
            </template>
          </div>
        </div>
      </ym-loadmore>
    </template>
    <empty-page v-if="showEmptyPage"
                hint="你还没有相关订单哦！"
    />
  </div>
</template>

<script>
  import { Button, Loadmore } from '@ymba/ym-ui';
  import EmptyPage from '@/components/EmptyPage';
  import Cover from '@/components/ProductCover';
  import { getMyOrderList, cancelOrder } from '@/services/order';
  import { getProductPath, projectJump } from '@/utils';
  import joinProductMixin from '@/mixins/order/joinProduct';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'MyOrderList',
    mixins: [joinProductMixin],
    components: {
      'ym-loadmore': Loadmore,
      'ym-button': Button,
      EmptyPage,
      Cover,
    },
    props: {
      records: {
        type: Array,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      nextStart: {
        type: Number,
        required: true,
      },
      showEmptyPage: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        list: [],
        allLoad: false,
        loading: false,
        showShareMask: false,
        shareUrl: '',
        showEmpty: false,
      };
    },
    filters: {
      statusFilters(status) {
        const statusMap = {
          created: '未支付',
          cancelled: '已关闭',
          paid: '已支付',
        };
        return statusMap[status];
      },
    },
    watch: {
      records(val) {
        this.list = val;
      },
      nextStart(val) {
        this.start = val;
      },
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;
        const data = await getMyOrderList({
          limit: LIMIT,
          type: this.type,
          start: this.start,
        }, isLoadMore);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
      async handleCancelOrder(sn) {
        this.$dialog.confirm({ message: '确定取消该订单吗?' }).then(() => {
          this.cancelOrder(sn);
        });
      },
      async cancelOrder(sn) {
        await cancelOrder(sn);
        window.location.reload();
      },
      handlePayOrder(url, sn) {
        this.payActionMode(url, sn);
      },
      handleOrderDetail(sn) {
        const route = { name: 'OrderDetail', params: { sn } };
        this.$router.push(route);
      },
      handleProductDetail(product) {
        const { target, type, id } = product;
        let params = {
          type,
          id,
        };
        if (target) {
          params = {
            type: target.type,
            id: target.id,
          };
        }
        const route = getProductPath(params.type, params.id);
        projectJump(route);
      },
      handleCourseReview(type, id) {
        const route = { name: 'CreateReview', params: { type, id } };
        this.$router.push(route);
      },
      handleExpressDetail(express, sn) {
        if (express == null) return;
        const { status, postId } = express;
        if (status === 'unsent') {
          this.$toast('请耐心等待发货');
          return;
        }
        if (postId === '') {
          this.$router.push({ name: 'OrderDetail', params: { sn } });
          return;
        }
        this.$router.push({ name: 'ExpressDetail', params: { sn: postId } });
      },
    },
    created() {
      this.list = this.records;
      this.start = this.nextStart;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .order-list-component {
    height: 100%;
  }

  .order-list {
    background: @color-gray-lightest;
    overflow: hidden;
  }

  .item {
    display: flex;
    flex-direction: column;
    margin-top: @size-small;
    padding: 0 @size-base;
    background: @color-white;
    position: relative;

    &:last-child {
      &:after {
        height: 0;
      }
    }
  }

  .status-block {
    display: flex;
    justify-content: space-between;
    padding: @size-base 0;
    border-bottom: @border-base;
    font-size: @font-size-base;
    color: @color-text-light;

    .status {
      color: @color-text-lighter;

      &.highlight {
        color: @color-text-highlight;
      }
    }
  }

  .order-info {
    display: flex;
    padding: @size-small 0;
    border-bottom: @border-base;
  }

  .cover {
    margin-right: @size-base;
  }

  .product-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: @product-list-title-padding-top;

    .title {
      width: 100%;
      margin: 0;
      font-size: @font-size-medium;
      font-weight: @font-weight-primary;
      color: @color-text-base;
      line-height: 1.4;
    }

    .price-block {
      text-align: right;
      font-size: @font-size-base;
      color: @color-text-light;
    }

    .price {
      margin-left: @size-extra-small;
      font-size: @font-size-base;
      font-weight: @font-weight-primary;

      &.active {
        font-weight: @font-weight-primary;
        color: @color-highlight;
      }
    }
  }

  .tool-block {
    display: flex;
    justify-content: flex-end;
    padding: @size-small 0 @size-base 0;
  }

  .express-btn {
    margin-left: @size-small;
  }

  .tool-right-btn {
    margin-left: @size-small;
  }

  .page-empty-message {
    margin-top: @size-small;
  }
</style>
